
export class MenuCategoryResponse {
    public id: string = "";
    public name: string = "";
    public description: string = "";

    constructor() {
    }
}